import { render, staticRenderFns } from "./AdminPackReleaseNoteListDialog.vue?vue&type=template&id=4e5e708a"
import script from "./AdminPackReleaseNoteListDialog.vue?vue&type=script&lang=js"
export * from "./AdminPackReleaseNoteListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports